import React from 'react';
import { motion } from 'framer-motion';
import { Sun, Activity } from 'lucide-react';
import { MonitoringStatus } from '../../../types/solarMonitoring';

interface SolarMonitoringHeaderProps {
  monitoringStatus: MonitoringStatus | null;
}

export const SolarMonitoringHeader: React.FC<SolarMonitoringHeaderProps> = ({ monitoringStatus }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-gradient-to-r from-yellow-500 to-orange-500 rounded-lg p-6 text-white"
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <Sun className="h-8 w-8" />
          <div>
            <h1 className="text-2xl font-bold">Solar Panel Monitoring</h1>
            <p className="text-yellow-100">Real-time monitoring and alert management</p>
          </div>
        </div>
        <div className="text-right">
          <div className="flex items-center space-x-2 mb-2">
            <Activity className="h-5 w-5" />
            <span className="font-semibold">
              {monitoringStatus?.isMonitoring ? 'Online' : 'Offline'}
            </span>
          </div>
          <p className="text-sm text-yellow-100">
            Polling every {monitoringStatus?.pollIntervalSeconds}s
          </p>
        </div>
      </div>
    </motion.div>
  );
};